import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDStack,
} from '@facet-wealth/design';

export const HouseholdBalanceSheetFilterLozengesLayout = () => {
  return (
    <FDStack direction="row" spacing={1}>
      <MetaControlField attr="ownerId" />
      <MetaControlField attr="assetType" />
      <MetaControlField attr="liabilityType" />
      <MetaControlField attr="institutionId" />
    </FDStack>
  );
};

HouseholdBalanceSheetFilterLozengesLayout.defaultProps = {
};

HouseholdBalanceSheetFilterLozengesLayout.propTypes = {
};
